
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY } from "rxjs";
import { map } from 'rxjs/operators';
import { AppConfigService } from '../../../reactive-forms/services/app-config.service';
import { UserInfo } from 'src/app/userInfo';
//import { IHttpService } from './IHttpService';
@Injectable({
  providedIn: 'root'
})
export class HttpService extends BehaviorSubject<any> /*implements IHttpService*/ {
  public data: any[] = [];
  loading = true;
  //Token: string = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoicm9vdCIsImp0aSI6ImY4OWRmYWE5LWVhMjItNGJjNy1hNDJjLWRiOWIxNmI1NTU2YiIsIkJVSUQiOiIxIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQWRtaW5pc3RyYXRvciIsImV4cCI6MTY4NjA3NDUwOCwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1OTkyMSIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6NDIwMCJ9.POyQA05KSclGHXy21oL8rSp8z58vA0b6RBptiF8wDLw'
  constructor(private http: HttpClient, private environment: AppConfigService) {
    super([])
  }


  public fetch(APIURL: string, filter: string): any {
    return this.http
      .get(`${this.environment.oDataApi}/${APIURL}${filter}`)
      .pipe(
        map((data: any) => ({ data: data.value ? data.value : data, total: data['@odata.count'] ? data['@odata.count'] : data.value ? data.value.length : data.length })),
        map(res => ({ data: res['data'].map((response: any) => ({ ...response, Date: new Date(response.Date) })), total: res.total }))
      );
  }

  delete(APIURL: string): any {
    return this.http.delete<any>(`${this.environment.oDataApi}/${APIURL}`)
  }

  add(APIURL: string, data: any, httpHeaders?: any): any {
    return this.http.post(`${this.environment.oDataApi}/${APIURL}`, data,{headers: httpHeaders})
  }
  edit(APIURL: string, data: any): any {   
    return this.http.put<any>(`${this.environment.oDataApi}/${APIURL}`, data)
  }

  patch(APIURL: string, data: any): any {  
    const headers = new HttpHeaders({ 'Content-Type': 'application/json-patch+json' });
    const options = { headers: headers };
    return this.http.patch<any>(`${this.environment.oDataApi}/${APIURL}`, data,options)
  }

  public get(APIURL: string, httpHeaders?: any): any {
    return this.http
      .get(`${this.environment.oDataApi}/${APIURL}`,{headers: httpHeaders})     
  }
  
  getResponsetext(APIURL: string): any {
    return this.http.get(`${this.environment.oDataApi}/${APIURL}`, { responseType: 'text' });
  }
  post(APIURL: string, data: any): any {
    return this.http.post(`${APIURL}`, data)
  }

  postXML(APIURL: string, data: any): any {
    const headers = new HttpHeaders({ 'Accept': 'application/xml' });
    return this.http.post(`${this.environment.oDataApi}/${APIURL}`, data, { headers: headers, responseType: 'blob' });
  }
  


  public httpGetRequest(url) {
    return this.http.get(url)     
  }

  public httpGetRequestText(url) {
    return this.http.get(url, { responseType: 'text' })     
  }

  public getParamList(paramList: string[]): any {
    let APIURL: string = 'HH_PARAMS?$filter=PARAM_ID in (';
    if (paramList.length >0)
    {
      paramList.forEach((param,index) => {
        APIURL = APIURL + `${param} `;
        if ((index+1) < paramList.length )
          APIURL = APIURL + ','
      } );
      APIURL = APIURL + ')';

      return this.http
      .get(`${this.environment.oDataApi}/${APIURL}`); 
    }
    else 
     return EMPTY;
    
  }
}
